(function( $ ) {
	$( document ).ready( function() {
		var $document = $( document ),
			ajaxURL   = CommentsAjax.ajax_url || '',
			action    = CommentsAjax.action || '',
			IDForm    = CommentsAjax.id_form || '';

		$document.on( 'submit', '#' + IDForm, function( e ) {
			var $this          = $( this ),
				loader         = CommentsAjax.loader || '<span class="ajax-spinner"></span>',
				disconnect     = CommentsAjax.disconnect || 'Servers have exploded.',
				listArgs       = CommentsAjax.list_args || '',
				listNonce      = CommentsAjax.list_nonce || '',
				selector       = CommentsAjax.commentlist || false,
				$submit        = $this.find( ':input[type=submit]' ),
				$spinner       = $( loader ),
				postData       = {
					action: action,
					form_data: {},
					list: {
						args: listArgs,
						nonce: listNonce
					}
				},
				$html,
				$parent,
				displayMessage = function( m ) {
					var $wrapper = $( '<div class="error-message"></div>' ).html( m.message || '' );

					// This isn't an error, WooHoo!
					if ( m.error === 'success' ) {
						$wrapper.removeClass( 'error-message' ).addClass( 'success-message' );
					}

					$submit.before( $wrapper );
					setTimeout( function() {
						$wrapper.remove();
					}, 10000 );
				};

			// Get all the data from the form.
			$.each( $this.serializeArray(), function( i, e ) {
				if ( typeof e.name !== 'undefined' && typeof e.value !== 'undefined' ) {
					postData.form_data[ e.name ] = e.value;
				}
			} );

			// Turn the submit button off
			$submit.addClass( 'disabled' ).attr( { disabled: 'disabled' } );

			// Add a loading indicator
			$submit.after( $spinner );

			// Submit the comment via admin-ajax
			$.post(
				ajaxURL,
				postData,
				function( d, st ) {
					// We've got error messages
					if ( typeof d.error !== 'undefined' && d.error !== false ) {
						displayMessage( d );
					}
					// Success, do something....
					else if ( typeof d.html !== 'undefined' && d.html !== '' ) {
						// Make sure we don't replace the html with the form still in the middle of it
						$( '#cancel-comment-reply-link' ).trigger( 'click' );

						// Turn the reply in to an object
						$html = $( d.html );

						// Find the first comment's parent, automatic only works if there are comments already there.
						$parent = !selector ? $( '.bac-comment' ).first().parent() : $( selector );

						// Remove all the current comments
						$parent.find( '.bac-comment' ).remove();

						// Add the new comments list
						$parent.append( $html );

						// Mark our comment in the new stack
						$parent.find( '.bac-comment-' + d.comment_id ).addClass( 'new-comment' );

						// Scroll to the comment
						$( 'body, html' ).stop().animate(
							{ scrollTop: Math.ceil( $parent.find( '.bac-comment-' + d.comment_id ).offset().top ) },
							{ easing: 'linear', duration: 1000 }
						);

						// Blank out the form
						$this.find( 'textarea' ).val( '' );

						// Send a message to the user
						if ( d.message ) {
							displayMessage( { error: 'success', message: d.message, code: 200 } );
						}
					}
				},
				'json'
			)
			 .always( function() {
				 // Reactivate the submit button
				 $submit.removeClass( 'disabled' ).removeAttr( 'disabled' );

				 // Remove the loading indicator
				 $spinner.remove();
			 } )
			 .fail( function( d, st ) {
				 // Something has gone very wrong
				 displayMessage( { error: 'error', message: disconnect } );
			 } );

			e.preventDefault();
			return false;
		} );

	} );
})( jQuery );
